module.exports = __webpack_public_path__ + "img/dodgejs.0812d4b9.png";